import React from 'react';
import { useSelector } from 'react-redux';
import { selector as commonSelector } from '@store/common';
import { DateContainer, DateRange } from './styled';
import Shortcuts from './Shortcuts';
import CustomDateRangePicker from './CustomDateRangePicker';
import { TimeSpan } from '../../types';

const OverviewDatePicker: React.FC<{
  selectedTimeSpan: TimeSpan;
  dateChangeFn: (timeSpan: TimeSpan) => void;
}> = ({ dateChangeFn, selectedTimeSpan }) => {
  const common = useSelector(commonSelector);
  const { tzOffset, features } = common;
  const { overviewDate } = features;
  const containerRef: any = React.useRef(null);

  const setDateCb = (obj: TimeSpan) => {
    dateChangeFn(obj);
  };

  return (
    <DateRange id="app-timeline-date-picker" ref={containerRef}>
      <DateContainer>
        <Shortcuts
          selectedInterval={selectedTimeSpan}
          overviewDate={overviewDate}
          tzOffset={tzOffset}
          setDateCb={setDateCb}
        />

        <CustomDateRangePicker
          overviewDate={overviewDate}
          tzOffset={tzOffset}
          containerRef={containerRef}
          setDateCb={setDateCb}
          selectedInterval={selectedTimeSpan}
        />
      </DateContainer>
    </DateRange>
  );
};

export default OverviewDatePicker;
